import { Col, Row } from "react-bootstrap";

export default function EmptyRow({ text = "No results" }) {
    return (
        <Row className="py-1 border-bottom">
            <Col className=" text-center">{text}</Col>
        </Row>
    );
}
